<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <factor-tree-query ref="factor-tree" :factor-tree="factorTree" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch :default-unit-prop.sync="unitProp" @change="onUnitPropChange" />
      </template>

      <polar-scatter-chart-group
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import YaoBaseSiteFactorData from '../../../../YaoBaseSiteFactorData'
import DeviceCategoryConfig from '../../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../../components/Layout/Content'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../../components/Data/UnitSwitch'
import PolarScatterChartGroup from './PolarScatterChartGroup'

export default {
  name: 'ScatterChart',
  routeInfo: {
    label: '污染物散点图',
    icon: 'fa fa-users'
  },
  data () {
    return {
      query: {
        factorIds: [],
        isMultipleIntegral: true
      }
    }
  },
  extends: YaoBaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, FactorTreeQuery, CompletedQuery, DataWrapper, UnitSwitch, PolarScatterChartGroup},
  computed: {
    isSetAllFactorIds: () => 4,
    requiredFactorIds: () => ['1012', '1013'],
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, true),
      new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, true, siteDeviceFactors => {
        let siteDeviceFactorMap = siteDeviceFactors.reduce((map, siteDeviceFactor) => {
          map[siteDeviceFactor.factorId] = siteDeviceFactor
          return map
        }, {})

        let windSpeed = siteDeviceFactorMap['1012']
        let newSiteDeviceFactors = []

        if (windSpeed) {
          let windDir = siteDeviceFactorMap['1013']

          if (windDir) {
            newSiteDeviceFactors.push(windSpeed, windDir)
          }
        }

        return newSiteDeviceFactors
      })
    ],
    factorTree () {
      return JSON.parse(JSON.stringify(this._factorTree.filter(factorGroup => factorGroup.id !== 'a01000')))
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/01Meteorological/01Pollutant-Chart/index.vue